import { create } from 'apisauce';

/**
 *
 * @param {int} orgId
 * @returns if migration is running:
 * { 'started_update': true, 'no_weddings_to_update: false, 'job_id': {id}}
 * if migration is not needed
 * { 'started_update': false, 'no_weddings_to_update': true }
 */
export const syncProjectsToES = async (userId) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/organization/${userId}/weddings/update_cache`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  // #TODO: Handle errors in this response better. Check for ok status.
  const response = await api.get();
  return response.data;
};

export const checkSyncStatus = async (userId, jobId) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/organization/${userId}/weddings/update_cache/check_status/${jobId}`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  // #TODO: Handle errors in this response better. Check for ok status.
  const response = await api.get();
  return response.data;
};
